declare namespace $ {

	type $mol_view__sub_shm_hitalama_map_selectbox_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_selectbox_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_selectbox_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_selectbox_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_selectbox['grouping'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_selectbox_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_selectbox_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_selectbox_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_selectbox['delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_selectbox_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_selectbox_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_selectbox['toolbar_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_map_selectbox_10 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_selectbox['toolbar_transform'] >,
			'top': ReturnType< $shm_hitalama_map_selectbox['toolbar_style_top'] >,
			'width': string,
			'maxWidth': ReturnType< $shm_hitalama_map_selectbox['toolbar_tools_max_width'] >,
			'marginLeft': ReturnType< $shm_hitalama_map_selectbox['toolbar_tools_left'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	export class $shm_hitalama_map_selectbox extends $shm_hitalama_map_float {
		transition( ): string
		count_title( ): string
		Count( ): $mol_view
		Group_icon( ): $mol_icon_group
		grouping( next?: any ): any
		Group( ): $mol_button_minor
		Delete_icon( ): $mol_icon_trash_can
		delete( next?: any ): any
		Delete( ): $mol_button_minor
		Tools( ): $mol_view
		toolbar_transform( ): string
		toolbar_style_top( ): string
		toolbar_tools_max_width( ): string
		toolbar_tools_left( ): string
		dragged_attr( ): boolean
		selected_links( ): readonly($giper_baza_link)[]
		style( ): ({ 
			'transition': ReturnType< $shm_hitalama_map_selectbox['transition'] >,
		})  & ReturnType< $shm_hitalama_map_float['style'] >
		sub( ): readonly(any)[]
		sidebar( ): readonly(any)[]
		toolbar_content( ): readonly(any)[]
		Toolbar( ): $mol_view
		attr( ): ({ 
			'shm_hitalama_map_selectbox_dragged': ReturnType< $shm_hitalama_map_selectbox['dragged_attr'] >,
		})  & ReturnType< $shm_hitalama_map_float['attr'] >
	}
	
}

//# sourceMappingURL=selectbox.view.tree.d.ts.map